(function () {
  'use strict';

  if (window.__hvBundleFlavorGuard) return;

  var BUNDLES = {
    45144349606083: {
      count: 3,
      url: '/products/mix-match-sea-moss-gels-pick-any-3'
    },
    45198442561731: {
      count: 4,
      url: '/products/pick-any-4-sea-moss-gels-bundle'
    }
  };
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    '.shopify-payment-button',
    'shopify-accelerated-checkout-cart'
  ].join(',');
  var invalidItems = [];
  var cartReady = false;
  var cartRequest = null;
  var banner = null;

  function value(properties, key) {
    var raw = properties && properties[key];
    return typeof raw === 'string' ? raw.trim() : '';
  }

  function legacyFlavorCount(properties) {
    var list = value(properties, 'Selected Flavors') || value(properties, 'Flavors');
    if (!list) return 0;
    return list.split(/[|,]/).map(function (name) {
      return name.trim();
    }).filter(Boolean).length;
  }

  function bundleConfig(item) {
    var id = Number(item && (item.variant_id || item.id));
    return BUNDLES[id] || null;
  }

  function isComplete(item) {
    var config = bundleConfig(item);
    if (!config) return true;
    var properties = item.properties || {};
    for (var index = 1; index <= config.count; index += 1) {
      if (!value(properties, 'Gel ' + index) && !value(properties, 'Flavor ' + index)) {
        return legacyFlavorCount(properties) >= config.count;
      }
    }
    return true;
  }

  function invalidBundleItems(cart) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (item) {
      return bundleConfig(item) && !isComplete(item);
    });
  }

  function ensureBanner() {
    if (banner && banner.isConnected) return banner;
    banner = document.createElement('div');
    banner.id = 'hv-bundle-flavor-guard';
    banner.setAttribute('role', 'alert');
    banner.setAttribute('aria-live', 'assertive');
    banner.innerHTML = [
      '<div class="hv-bfg-card">',
      '<button type="button" class="hv-bfg-close" aria-label="Close">&times;</button>',
      '<strong>Choose your bundle flavors</strong>',
      '<p>This bundle is missing flavor selections. Pick your flavors before checkout.</p>',
      '<button type="button" class="hv-bfg-repair">Choose flavors</button>',
      '<p class="hv-bfg-error" hidden></p>',
      '</div>'
    ].join('');
    var style = document.createElement('style');
    style.id = 'hv-bundle-flavor-guard-styles';
    style.textContent = [
      '#hv-bundle-flavor-guard{position:fixed;z-index:2147483000;inset:auto 16px 18px 16px;display:flex;justify-content:center;font-family:inherit}',
      '#hv-bundle-flavor-guard[hidden]{display:none}',
      '.hv-bfg-card{position:relative;width:min(100%,520px);padding:20px 52px 20px 20px;border:2px solid #b42318;border-radius:14px;background:#fff7f5;color:#32100d;box-shadow:0 12px 40px rgba(50,16,13,.22)}',
      '.hv-bfg-card strong{display:block;font-size:18px;line-height:1.25}',
      '.hv-bfg-card p{margin:7px 0 14px;font-size:14px;line-height:1.45}',
      '.hv-bfg-repair{min-height:44px;padding:10px 18px;border:0;border-radius:999px;background:#173f35;color:#fff;font:inherit;font-weight:700;cursor:pointer}',
      '.hv-bfg-repair[disabled]{opacity:.65;cursor:wait}',
      '.hv-bfg-close{position:absolute;right:14px;top:10px;border:0;background:transparent;color:#32100d;font-size:28px;line-height:1;cursor:pointer}',
      '.hv-bfg-error{color:#b42318;font-weight:700}',
      '[data-hv-bundle-guard-disabled="true"]{opacity:.48!important;cursor:not-allowed!important}',
      'shopify-accelerated-checkout-cart[data-hv-bundle-guard-disabled="true"],.shopify-payment-button[data-hv-bundle-guard-disabled="true"]{display:none!important}',
      '@media(min-width:700px){#hv-bundle-flavor-guard{inset:auto 24px 24px auto}.hv-bfg-card{width:440px}}'
    ].join('');
    document.head.appendChild(style);
    document.body.appendChild(banner);

    banner.querySelector('.hv-bfg-close').addEventListener('click', function () {
      banner.hidden = true;
    });
    banner.querySelector('.hv-bfg-repair').addEventListener('click', repairCart);
    return banner;
  }

  function showBanner() {
    var element = ensureBanner();
    element.hidden = false;
    element.querySelector('.hv-bfg-error').hidden = true;
  }

  function setCheckoutDisabled(disabled) {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (control) {
      if (disabled) {
        control.setAttribute('data-hv-bundle-guard-disabled', 'true');
        control.setAttribute('aria-disabled', 'true');
        if ('disabled' in control) control.disabled = true;
      } else if (control.getAttribute('data-hv-bundle-guard-disabled') === 'true') {
        control.removeAttribute('data-hv-bundle-guard-disabled');
        control.removeAttribute('aria-disabled');
        if ('disabled' in control) control.disabled = false;
      }
    });
  }

  function applyCart(cart) {
    invalidItems = invalidBundleItems(cart);
    cartReady = true;
    setCheckoutDisabled(invalidItems.length > 0);
    if (invalidItems.length) showBanner();
    else if (banner) banner.hidden = true;
    return invalidItems;
  }

  function refreshCart(force) {
    if (cartRequest && !force) return cartRequest;
    cartRequest = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to inspect cart');
      return response.json();
    }).then(applyCart).catch(function () {
      cartReady = false;
      return invalidItems;
    }).finally(function () {
      cartRequest = null;
    });
    return cartRequest;
  }

  function repairCart() {
    if (!invalidItems.length) return;
    var element = ensureBanner();
    var button = element.querySelector('.hv-bfg-repair');
    var error = element.querySelector('.hv-bfg-error');
    var config = bundleConfig(invalidItems[0]);
    var updates = {};
    invalidItems.forEach(function (item) {
      updates[item.key] = 0;
    });
    button.disabled = true;
    button.textContent = 'Opening flavor builder...';
    error.hidden = true;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update cart');
      window.location.assign(config.url);
    }).catch(function () {
      button.disabled = false;
      button.textContent = 'Try again';
      error.textContent = 'We could not update your cart. Please refresh and try again.';
      error.hidden = false;
    });
  }

  function blockCheckout(event) {
    if (!invalidItems.length) return false;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    showBanner();
    refreshCart(true).then(function (items) {
      if (items.length) showBanner();
    });
    return true;
  }

  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if (!control) return;
    if (blockCheckout(event)) return;
    if (!cartReady) {
      event.preventDefault();
      event.stopPropagation();
      refreshCart(true).then(function (items) {
        if (items.length) showBanner();
        else window.location.assign('/checkout');
      });
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    var checkoutIntent = submitter && submitter.matches && submitter.matches('[name="checkout"]');
    if (!checkoutIntent && event.target && event.target.action) {
      checkoutIntent = /\/checkout(?:[/?#]|$)/.test(event.target.action);
    }
    if (!checkoutIntent) return;
    blockCheckout(event);
  }, true);

  ['variant:add', 'cart:refresh', 'cart:change', 'cart:drawer:change'].forEach(function (name) {
    document.addEventListener(name, function () { refreshCart(true); });
  });

  var observer = new MutationObserver(function () {
    if (cartReady) setCheckoutDisabled(invalidItems.length > 0);
  });

  function init() {
    observer.observe(document.documentElement, { childList: true, subtree: true });
    refreshCart(true);
  }

  window.__hvBundleFlavorGuard = {
    bundleConfig: bundleConfig,
    isComplete: isComplete,
    invalidBundleItems: invalidBundleItems,
    refresh: refreshCart
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
